module.exports = "./assets/assets/确定政府采购方式流程图.43c004ba.docx";